import { RicosPluginToolbarNames } from 'ricos-types';
import { DEFAULTS } from './constants.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { GIPHY_TYPE } from './types.js';
import 'wix-rich-content-common';
import 'wix-rich-content-editor-common';
import './modals/InsertModal.js';
import 'react';
import 'ricos-content/libs/convertBlockDataToRicos';
import 'ricos-context';
import './giphyApiInputModal-7b1d31ad.js';
import 'classnames';
import 'lodash';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './dataHooks.js';
import './toolbar/giphySelector.js';
import 'react-custom-scrollbars';
import 'react-infinite-scroller';
import './giphyEmptyState-6b01c652.js';
import './toolbar/getGiphyProxyUrl.js';
import './icons/PoweredByGiphy.js';
import './icons/InsertPluginIcon.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-toolbars-ui';
import 'ricos-content';
import 'ricos-schema/dist/statics/gif.defaults.json';
import './tiptap/component.js';
import './viewer/giphy-viewer.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginGiphy = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: GIPHY_TYPE,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2),
    toolbar: {
      names: [RicosPluginToolbarNames.GIF],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    }
  };
};

export { pluginGiphy };
//# sourceMappingURL=editor.js.map
